import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';

export const adminAuthGuard: CanActivateFn = (): boolean | UrlTree => {
  const router = inject(Router);

  if (localStorage.getItem('admin_access_token')) return true;

  return router.createUrlTree(['/admin/login']);
};
